module.exports = "<p>extraction-demnade-par-profil works!</p>\r\n"